import { create } from 'zustand';
import { PaymentStatusData } from '@/bridge/types';

interface WebViewPaymentModalStore {
  isOpen: boolean;
  paymentData: PaymentStatusData | null;
  open: (paymentData: PaymentStatusData) => void;
  close: () => void;
}

export const useWebViewPaymentModalStore = create<WebViewPaymentModalStore>(
  set => ({
    isOpen: false,
    paymentData: null,
    open: value => set({ paymentData: value, isOpen: true }),
    close: () => set({ isOpen: false }),
  })
);
